// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__vNYy-","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__DlLzX"};